/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { ProvideTimers, TimerProps } from '@blend/shared-react';
import { BlendBridge } from 'blb-types/blendBridge';

import { FeesTab } from './FeesTab';

export interface FeesTabWithTimerProps {
  loan: BlendBridge.API.Loan;
  order: Title.Orders.Order;
  userId: string;
}

export const FeesTabWithTimer: React.FC<FeesTabWithTimerProps> = (props: FeesTabWithTimerProps) => {
  return <ProvideTimers render={(timerProps: TimerProps) => <FeesTab {...timerProps} {...props} />} />;
};
